<template>
  <main>
    <Header :loginSource="loginSource"></Header>

    <section class="merchant_container" v-if="courseWrapper.course">
      <div class="merchant_wrapper">
        <div class="order_title">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/course', query: {no: no, activeName: 'third'} }">返回课程</el-breadcrumb-item>
            <el-breadcrumb-item>{{courseWrapper.course.name}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{video.name}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <hr>
        <div class="merchant_block">
          <div class="merchant_content">
            <div class="video_menu_wrapper">
              <div>
                <el-link :underline="false" disabled>目录</el-link>
              </div>
              <div v-for="(v, index) in courseWrapper.videos" :key="index">
<!--                <el-link v-if="v.charge === 0" :underline="false" :type="v.videoNo === videoNo ? 'primary' : 'default'" @click="playVideo(v.videoNo, index)">-->
<!--                  <el-tag type="success" disable-transitions>免费</el-tag> {{v.name}}-->
<!--                </el-link>-->
<!--                <el-link v-else :underline="false" :type="v.videoNo === videoNo ? 'primary' : 'default'" @click="playVideo(v.videoNo, index)">-->
<!--                  <el-tag type="danger" disable-transitions>{{isBuyCourse ? '已付费' : '付费'}}</el-tag> {{v.name}}-->
<!--                </el-link>-->

                <div :id="v.videoNo" class="menu_item_wrapper" @click="playVideo(v.videoNo, index)">
                  <div style="margin-right: 4px;">
                    <el-tag v-if="v.charge === 0" type="success" disable-transitions>免费</el-tag>
                    <el-tag v-else type="danger" disable-transitions>{{isBuyCourse ? '已付费' : '付费'}}</el-tag>
                  </div>
                  <div class="menu_item_name">
                    <el-link :underline="false" :type="v.videoNo === videoNo ? 'primary' : 'default'">
                      {{v.name}}
                    </el-link>
                  </div>
                  <span class="menu_item_time">{{v.durationStr}}</span>
                </div>

              </div>
            </div>
            <div style="width: 70vw; height: 70vh">
<!--              <video :id="playerId" width="1120" height="630" preload="auto" playsinline webkit-playsinline>-->
<!--              </video>-->
              <video :id="playerId" style="width: 100%; height: 100%;" preload="auto" playsinline webkit-playsinline>
              </video>
              <p class="play_tips"><i class="el-icon-info"></i> 建议使用谷歌浏览器观看视频；如果遇到视频播放异常，请刷新页面或重新登录后观看。</p>
              <p class="play_tips"><i class="el-icon-info"></i> 所有付费课程视频均是2K超清画质。</p>
            </div>

          </div>
          <br>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </main>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { getPhone, getToken } from '@/common/auth'
import { AESDecrypt } from '@/common/myaes'
import {mapGetters, mapState} from 'vuex'
import {
  reqGetCourseVideo,
  reqFindCourseVideos,
  reqCheckBuyCourse,
  reqUpdateCoursePlayInfo
} from '@/api'

export default {
  name: 'PlayCourse',
  components: {Header, Footer},
  comments: {
    Header
  },

  data() {
    return {
      no: parseInt(this.$route.query.no), // 课程编号
      videoNo: parseInt(this.$route.query.videoNo), // 视频编号
      video: {},
      player: {},
      loginSource: 2*1000 + parseInt(this.$route.query.no),
      playerId: 'player-container-' + new Date().getTime(),
      isBuyCourse: false,
      isPlayerInited: false,
      loginPhone: '',
      switchVideo: false, // 是否切换视频 用于控制视频暂停后播放时，是否重新创建定时任务
      interval: {},
      intervalCleaned: false
    }
  },

  async mounted () {
    if (!this.isLogin) {
      await this.$router.push('/index')
      return
    }

    if (!this.no || !this.videoNo) {
      await this.$router.push('/index')
      return
    }
    if (!this.courseWrapper.course) {
      await this.getCourseVideos()
    }

    // 跳转到滚动条指定位置
    window.location.hash= '#' + this.videoNo;

    await this.checkBuyCourse()
    this.loginPhone = getPhone()
    await this.getCourseVideo()
    this.initTCPlayer()
  },

  methods: {

    // 获取视频列表
    async getCourseVideos () {
      const result = await reqFindCourseVideos(this.no)
      if (result.code === 0) {
        const courseWrapper = result.data
        await this.$store.dispatch('setCourseWrapper', {courseWrapper})
      }
    },

    // 获取单个视频播放信息
    async getCourseVideo () {
      const result = await reqGetCourseVideo(this.no, this.videoNo)
      if (result.code === 0) {
        this.video = result.data

        this.switchVideo = true
        clearInterval(this.interval)
      } else {
        await this.$alert(`${ result.message }`, '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push({
              path: '/course',
              query: {no: this.no, activeName: 'third'}
            }).catch(err=>{})
          }
        })
      }
    },

    // 播放选中的视频
    async playVideo (videoNo, index) {
      const selectedVideo = this.courseWrapper.videos[index]

      // 如果视频需要付费，但课程未购买
      if (selectedVideo.charge && !this.isBuyCourse) {
        await this.$alert('课程未购买，请购买后再播放', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return
      }

      this.videoNo = videoNo
      await this.getCourseVideo(this.no, this.videoNo)

      // this.player.loadVideoByID({
      //   fileID: this.video.fileId,
      //   appID: this.video.appId,
      //   psign: this.video.psign,
      // });

      this.player.loadVideoByID({
        fileID: AESDecrypt(this.video.fileId),
        appID: parseInt(AESDecrypt(this.video.appId)),
        psign: AESDecrypt(this.video.psign),
      });

      // this.player.src(this.video.url) // url 播放地址
    },

    // 检查是否购买了课程
    async checkBuyCourse () {
      const result = await reqCheckBuyCourse(this.no)
      if (result.code === 0) {
        this.isBuyCourse = true
      } else {
        this.isBuyCourse = false
      }
    },

    // 创建tcplayer
    initTCPlayer () {
      const that = this

      // key防盗链方式
      // this.player = TCPlayer(this.playerId, {})
      // this.player.src(this.video.url) // url 播放地址
      // this.isPlayerInited = true
      // this.player.on('ended', function(e) {
      //   this.exitFullscreen()
      // })

      // this.player = TCPlayer(this.playerId, {
      //   fileID: this.video.fileId,
      //   appID: this.video.appId,
      //   psign: this.video.psign,
      //   plugins:{
      //     DynamicWatermark: {
      //       opacity: 0.6,
      //       speed: 0.2,
      //       color: 'red',
      //       content: this.loginPhone + ' bigdataonk8s.com'
      //     }
      //   }
      // })

      this.player = TCPlayer(this.playerId, {
        fileID: AESDecrypt(this.video.fileId),
        appID: parseInt(AESDecrypt(this.video.appId)),
        psign: AESDecrypt(this.video.psign),
        autoplay: true,
        plugins:{
          DynamicWatermark: {
            opacity: 0.6,
            speed: 0.2,
            color: 'red',
            content: this.loginPhone + ' bigdataonk8s.com'
          },
          ContinuePlay: {
            auto: true,
          }
        }
      })

      this.isPlayerInited = true
      this.player.on('ended', function(e) {
        if (this.isFullscreen()) {
          this.exitFullscreen()
        }
      })

      // one监听的事件只处理一次
      this.player.on('play', function(e) {
        that.updateCoursePlayInfo()
      })
    },

    // 上报更新播放记录
    updateCoursePlayInfo() {
      if (this.switchVideo) {
        this.switchVideo = false
        const waitTime = Math.floor(this.video.duration * 0.7)
        let that = this
        that.interval = setInterval(async () => {
          // 播放中途退出，需要清除定时器
          if (!getToken()) {
            that.intervalCleaned = true
            clearInterval(this.interval)
            return
          }
          const result = await reqUpdateCoursePlayInfo(that.no, that.video.videoNo, waitTime)
          that.intervalCleaned = true
          clearInterval(that.interval)
        }, waitTime * 1000);
      }

    }

  },

  computed: {
    ...mapState(['courseWrapper']),
    ...mapGetters(['isLogin']),
  },

  destroyed() {
    if (!this.intervalCleaned) {
      this.intervalCleaned = true
      clearInterval(this.interval)
    }
    if (this.isPlayerInited) {
      this.isPlayerInited = false
      this.player.dispose()
    }
  }

}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .merchant_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    /*background: #eee;*/
  }

  .merchant_wrapper {
    width: 100%;
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }

  .order_title {
    /*line-height: 40px;*/
    margin-top: 20px;
    font-size: 18px;
    font-weight: 500;
  }

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .merchant_content {
    display: flex;
  }

  .merchant_desc div:first-child {
    font-size: 24px;
    color: #000;
    font-weight: bold;
  }

  .merchant_desc div {
    line-height: 30px;
    /*font-size: 14px;*/
    /*color: #999;*/
  }

  .video_menu_wrapper {
    /*width: 360px;*/
    /*height: 680px;*/
    width: 23vw;
    max-width: 420px;
    height: 73vh;
    overflow: scroll;
    line-height: 30px;
    background: #eee;
    padding: 10px;
    margin-right: 10px;
  }

  .play_tips {
    font-size: 12px;
    color: #999;
  }

  .menu_item_wrapper {
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
    cursor: pointer;
  }

  .menu_item_name {
    line-height: 30px;
    font-size: 14px;
    color: #666;
    padding-right: 4px;
  }

  .menu_item_time {
    line-height: 30px;
    font-size: 12px;
    color: #999;
    margin-left: auto;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PlayCourse/PlayCourse.vue